import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { AuthResponseData } from '../auth-model/user.model';
import { throwError, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { UrlModal } from 'src/app/shared/url.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  // URL = 'http://206.189.132.38:3005';
  URL= 'https://dev.api.doqmatokens.com';

  authDataSubject = new BehaviorSubject<AuthResponseData>(null);

  constructor(private httpClient: HttpClient, private router: Router) {}

  loginhm(username: string, password: string) {
    console.log(password);
    return this.httpClient
      .post<User>(UrlModal._URL + '/doc/authdoc', {
        email: username,
        password: password,
      })
      .pipe(
        tap((userRes) => {
          console.log(userRes);
          const authResponse = new AuthResponseData(
            userRes.response.userData.id,
            userRes.response.token,
            userRes.response.userData.email,
            userRes.response.userData.userType,
            userRes.response.userData.type,
          );
          localStorage.setItem('authData', JSON.stringify(authResponse));
          this.autoLogin();
          this.authDataSubject.next(authResponse);
        }),
        catchError((errorRes) => {
          let errorMessage = 'An unknown error occured';
          switch (errorRes.error.message) {
            case 'Email not found':
              errorMessage = "Username you entered doesn't match any account";
              break;
            case 'Password did not match':
              errorMessage = 'Password did not match';
              break;
          }
          return throwError(errorMessage);
        })
      );
  }
  autoLogin() {
    const authData: {
      id: string;
      token: string;
      email: string;
      userType: string;
      type: string;
    } = JSON.parse(localStorage.getItem('authData'));
    console.log(JSON.parse(localStorage.getItem('authData')));
    if (!authData) {
      return;
    }
    const loadedAuthData = new AuthResponseData(
      authData.id,
      authData.token,
      authData.email,
      authData.userType,
      authData.type
    );
    if (authData.token) {
      this.authDataSubject.next(loadedAuthData);
    }
  }
  onLogout() {
    this.authDataSubject.next(null);
    localStorage.removeItem('authData');
    localStorage.clear();
    this.router.navigate(['/auth']);
  }
  ondashboardLogOut(){
    this.authDataSubject.next(null);
    localStorage.removeItem('authData');
    localStorage.clear();
  }
  patientlogin(data:any){
    return this.httpClient.post(UrlModal._URL + '/pat/getloginotp' , data);
  }
  otpmail(email:any){
    let payload = {
      email:email
    }
    return this.httpClient.post(UrlModal._URL + '/doc/emailverify',payload)
  }

  Emergencyappt(clinic:any,date:any,token:string){
    let payload = {
    clinicId : clinic,
    appointmentDate:date
    }
    return this.httpClient.post(UrlModal._URL + '/ap/getemergencyappcount',payload,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
  });
 }
  otplogin(otp:any,phoneNo:any){
    let payload = {
      otp:otp, 
      phoneNo:phoneNo
    }
    return this.httpClient.post(UrlModal._URL + '/doc/loginpatient',payload);
  }
  changePass(pass:any,phoneNo:any,id:any,token:any){
    let payload ={
      phoneNo:phoneNo,
      id:id,
      password:pass
    }
    return this.httpClient.post(UrlModal._URL + '/doc/updatepassword',payload,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    });
  }
  //  SUBSCRIPTION LOGIN VIA OTP. // NEW FUNCTIONALITY

  subscriptionLoginOtp(phoneNo:number,name:string){
    let payload = {
      phoneNo:phoneNo,
      name:name
    }
    return this.httpClient.post(UrlModal._URL + '/phn/psublogin',payload);
      // headers: new HttpHeaders({
      //   authorization: 'Bearer ' + token,
      // }),
    // });
  }
  authenticateOTP(otp:number,phoneNo:number,name:string){
     var postData = {
        phoneNo: phoneNo,
        otp: otp,
        name:name
      };
      return this.httpClient.post(UrlModal._URL + '/pat/loginpatient',postData);
  }
// Inside your Angular Service File (e.g., payment.service.ts)

patientSubscriptionOrderCreate(postData: any) {
  // It uses your configured domain: UrlModal._URL + '/pay/savingrazorpayorder'
  return this.httpClient.post<any>(UrlModal._URL + '/pay/savingrazorpayorder', postData,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + postData.token,
      }),
    });
}

verifySubscriptionPayment(postData:any){
  return this.httpClient.post<any>(UrlModal._URL + '/pay/verifysubscriptionp',postData,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + postData.token,
      }),
    });
}

//  verify SSO TOKEN and get the actual token 

verifySsoToken(ssotoken:any){
  return this.httpClient.post<any>(UrlModal._URL + '/pat/verifyssotoken',{ssoToken:ssotoken});
}

//  verification subscription payment new webhook method payment


getSubscriptionStatus(orderId: string, token: string) {
  return this.httpClient.get<any>(UrlModal._URL + `/pat/sub/stat/${orderId}`,{
    headers: new HttpHeaders({
      authorization: 'Bearer ' + token
    })
  })
}

  RegisterDoctorToDatabase(
    name: string,
    doctorType: string,
    email: string,
    experience: number,
    degree: string,

    line1: string,
    city: string,
    pincode: number,
    state: string,
    memberCouncil,
    patientLimit,

    consFee,
    clinicDays,

    clinic: string,
    phoneNo,
    password,
    memberCouncilId
  ) {
    return this.httpClient.post(UrlModal._URL + '/doc/adddoc', {
      name: name,
      doctorType: doctorType,
      email: email,
      experience: experience,
      degree: degree,

      line1: line1,
      city: city,

      pincode: pincode,

      state: state,

      clinic: clinic,
      memberCouncil: memberCouncil,
      patientLimit: patientLimit,

      consFee: consFee,
      clinicDays: clinicDays,
      phoneNo: phoneNo,
      password: password,
      memberCouncilId: memberCouncilId,
    });
  }
}
export interface User {
  response: {
    token: string;
    userData: {
      token: string;
      id: string;
      email: string;
      userType: string;
      type:string;
    };
  };
} 